<template>
  <div v-if="newsList.length > 0" class="newses-container">
    <h4 class="about-title">{{ category.categoryName !== undefined ? category.categoryName : categoryName }}</h4>
    <div class="news-list">
      <div v-for="(news, index) in newsList" :key="index" class="news-item">
        <router-link class="news-item-parent-link" :to="linkPrefix + news.url">
          <b-media right-align>
            <b-link :to="linkPrefix + news.url" slot="aside">
              <b-img center class="news-item-img align-self-center" :src="middleThumnailUrl(host + news.thumbnailUrl)" width="240" height="135" :alt="news.title" />
            </b-link>
            <p class="news-item-tools">
              <span class="news-item-tab">{{ news.categoryName }}</span>
              <span class="news-item-time">{{ news.addTimeMMddyyyyHHmm }}</span>
            </p>
            <h5 class="news-item-title">
              <b-link class="news-link-title" :to="linkPrefix + news.url">{{ news.title }}</b-link>
            </h5>
            <div class="news-content">
              {{ news.shortContent }}
            </div>
          </b-media>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["category", "newsList"],
  computed: {
    host() {
      return this.$store.state.host;
    },
    linkPrefix() {
      return this.$route.params.ln !== undefined
        ? "/" + this.$route.params.ln
        : "";
    },

    categoryName() {
      return this.$store.state.languagePack.ls_AllNews;
    }
  },
  methods: {
    middleThumnailUrl(stringUrl) {
      return stringUrl.replace("_small.", "_middle.");
    }
  }
};
</script>

<style lang="scss">
.newses-container {

  .news-list {
    border: 1px solid #dddfe2;
    background-color: #ffffff;
    padding: 0 1rem;
    padding-bottom: 0;

    .news-item {
      border-bottom: 1px solid #f0f0f0;
      min-height: 9.375rem;
      margin: 0 -15px;
      padding: 0 15px;

      &:hover {
        background-color: #f0f8f9;
      }

      .news-item-parent-link {
        display: block;
        text-decoration: none;
        padding: 0.875rem 0;
      }

      &:last-child {
        border-bottom: 0;
      }

      .news-item-img {
        vertical-align: middle;
      }

      .news-item-tools {
        margin-bottom: 0.5rem;
        font-size: 0.875rem;
        color: #585858;

        .news-item-tab {
          padding: 0 0.5rem;
          background-color: #ffffff;
          border: 1px solid #00849655;
          border-radius: 0.125rem;
          margin-right: 0.5rem;
          font-size: 13px;
          color: #008496cc;
        }

        .news-item-time {
          margin-left: 0.25rem;
          color: #959595;
        }
      }

      .news-item-title {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;

        .news-link-title {
          font-size: 18px;
          color: #212525;

          &:hover {
            text-decoration: none;
          }
        }
      }

      .news-content {
        color: #959595;
        font-size: 0.875rem;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
      }
    }

    .no-data {
      padding: 1rem 0;
      color: #959595;

      i {
        color: darkorange;
      }
    }
  }
}

/* RTL */

.rtl-layout .newses-container {

  .news-item-parent-link {

    .media {
      direction: rtl;

      .ml-3 {
        margin-left: 0 !important;
        margin-right: 15px;
      }

      .media-body * {
        direction: rtl;
        text-align: right;
      }

      .news-item-tab {
        margin-right: 0;
        margin-left: 8px;
      }
    }
  }
}
</style>
